const RoadmapHyfye = () => {
  return (
    <section id="roadmap" className="bg_light_dark">
      <div className="container">
        <div className="row text-center">
          <div className="col-lg-8 col-md-12 offset-lg-2">
            <div className="title_default_light title_border text-center">
              <h4 className="animation" data-animation="fadeInUp" data-animation-delay="0.1s">Hyfye Roadmap</h4>
              <p className="animation" data-animation="fadeInUp" data-animation-delay="0.1s">
                Hyfye is pioneering the future of Hybrid Finance (Hyfye = Hybrid Finance for You and Everyone) — connecting real-world economic use cases to decentralized digital infrastructure.
              </p>
              <p className="animation" data-animation="fadeInUp" data-animation-delay="0.1s">
                The roadmap showcases a phased rollout of HYE token utilities and Hyfye Minis spanning finance, gaming, content creation, social media, fitness, marketplaces, and advertising.
              </p>
              <p className="animation" data-animation="fadeInUp" data-animation-delay="0.1s">
                With staking, multi-chain support, SDK tools, and governance on the horizon, Hyfye aims to become the modular infrastructure backbone for Web3 micro-economies.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12 pl-0 pr-0 col-lg-12 col-sm-12">
            <div className="roadmap owl-carousel small_space">

              {/* Phase 1: Token Genesis */}
              <div className="owl-item item">
                <div className="roadmap_box rd_complete current">
                  <div className="roadmap_inner">
                    <div className="icon_roadmap">
                      <i className="fa fa-rocket animation" data-animation="fadeInDown" data-animation-delay="0.1s"></i>
                    </div>
                    <div className="roadmap_icon"></div>
                    <h6 className="animation" data-animation="fadeInUp" data-animation-delay="0.1s">July 2025</h6>
                    <p className="animation" data-animation="fadeInUp" data-animation-delay="0.1s">Token Launch (HYE on BNB Chain)</p>
                  </div>
                </div>
              </div>

              {/* Phase 2: Minis + Collabs */}
              <div className="owl-item item">
                <div className="roadmap_box">
                  <div className="roadmap_inner">
                    <div className="icon_roadmap">
                      <i className="fa fa-cubes animation" data-animation="fadeInDown" data-animation-delay="0.1s"></i>
                    </div>
                    <div className="roadmap_icon"></div>
                    <h6 className="animation" data-animation="fadeInUp" data-animation-delay="0.1s">Q3 2025</h6>
                    <p className="animation" data-animation="fadeInUp" data-animation-delay="0.1s">Hyfye Minis Launch + Partner Integrations</p>
                  </div>
                </div>
              </div>

              {/* Phase 3: Platform & DEX */}
              <div className="owl-item item">
                <div className="roadmap_box">
                  <div className="roadmap_inner">
                    <div className="icon_roadmap">
                      <i className="fa fa-random animation" data-animation="fadeInDown" data-animation-delay="0.6s"></i>
                    </div>
                    <div className="roadmap_icon"></div>
                    <h6 className="animation" data-animation="fadeInUp" data-animation-delay="0.1s">Q4 2025</h6>
                    <p className="animation" data-animation="fadeInUp" data-animation-delay="0.1s">Beta Platform + In-App DEX & Wallet</p>
                  </div>
                </div>
              </div>

              {/* Phase 4: Governance + Staking */}
              <div className="owl-item item">
                <div className="roadmap_box">
                  <div className="roadmap_inner">
                    <div className="icon_roadmap">
                      <i className="fa fa-university animation" data-animation="fadeInDown" data-animation-delay="0.8s"></i>
                    </div>
                    <div className="roadmap_icon"></div>
                    <h6 className="animation" data-animation="fadeInUp" data-animation-delay="0.1s">Q1 2026</h6>
                    <p className="animation" data-animation="fadeInUp" data-animation-delay="0.1s">Community Governance + HYE Staking</p>
                  </div>
                </div>
              </div>

              {/* Phase 5: Multi-chain & Global Growth */}
              <div className="owl-item item">
                <div className="roadmap_box">
                  <div className="roadmap_inner">
                    <div className="icon_roadmap">
                      <i className="fa fa-globe animation" data-animation="fadeInDown" data-animation-delay="1s"></i>
                    </div>
                    <div className="roadmap_icon"></div>
                    <h6 className="animation" data-animation="fadeInUp" data-animation-delay="0.1s">Mid 2026</h6>
                    <p className="animation" data-animation="fadeInUp" data-animation-delay="0.1s">Multi-Chain Expansion + Global Utility Apps</p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RoadmapHyfye;
